let inject = [
  '$scope',
  'SharedService',
  'HomeService',
  '$state',
  '$rootScope',
  '$window',
  '$timeout',
  'MetatagService'
];

class HomeController {
  constructor($scope, SharedService,HomeService, $state, $rootScope, $window, $timeout, MetatagService) {
    this.$state = $state;
    this.$scope = $scope;
    this.$window = $window;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
    this.HomeService = HomeService;
    this.pageName = "PAG-1";

    this.SharedService.getCMSBanners(this.pageName, __env.adaptative ? 1:0).then(response => {
        this.cmsData = response;
        this.shCtrl.setTags(this.cmsData.seo);

    });
    this.$rootScope.$emit('onChangeCompany','');
  }

  $onInit() {

  }



}

HomeController.$inject = inject;

export default HomeController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/home.controller.js
 **/